// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".config-name[data-v-b95f1500] {\n  width: 189px;\n}\n.topology[data-v-b95f1500] {\n  width: 270px;\n}\n.server-version[data-v-b95f1500] {\n  width: 250px;\n}\n.version[data-v-b95f1500] {\n  width: 100px;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
